<template>
    <div class="gz-col-title">
        <span>{{ title }}</span>
    </div>
</template>

<script>
export default {
    name: 'BaseColTitle',

    props: {
        title: String
    }
}
</script>